import KioskCheckInContainer from "./kiosk-check-in-container";
import "./board-kiosk-empty-state.js";

$(document).ready(function () {
  const $lookup = $("#kiosk-registration-lookup-container");
  const $rsvp = $("#kiosk-signin-container");

  (window as unknown as { kioskCheckInContainer: InstanceType<typeof KioskCheckInContainer> }).kioskCheckInContainer = new KioskCheckInContainer({
    $container: $lookup,
    onRegisterSelected: () => {
      $lookup.hide();
      $rsvp.show();
    },
    onRegisterCompleted: () => {
      $rsvp.hide();
      $lookup.show();
    }
  });
});
